<template>
  <div class="column">
    <div class="card tilebox-one">
      <div class="card-body">
        <i class="dripicons-basket float-end text-muted"></i>
        <h6 class="text-muted text-uppercase mt-0">Accuracy</h6>
        <h2 class="m-b-20"><animated-number :value="+accuracyData.current" />%</h2>
        <span class="badge" :class="{'bg-primary' : accuracyData.previous > 0, 'bg-alert' : accuracyData.previous <= 0}"> <animated-number :value="+accuracyData.previous" />% </span> <span class="text-muted">From previous</span>
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedNumber from "../../../../components/AnimatedNumber";
import {mapGetters, mapActions} from 'vuex'

export default {
  name: "AccuracyCard",
  components: {
    AnimatedNumber
  },

  props: {
    params: null,
    paramsPrevious: null,
    user: {},
    value: null
  },

  methods: {
    ...mapActions({
      getaccuracy: "getAccuracy",
      getEstimatedTable: "getEstimatedTable"
    }),

    getCurrentAccuracy(){
      this.getaccuracy(this.params)
          .then((value) => {
            this.accuracyData.current = value.data
          })
    },

    getPreviousAccuracy(){
      this.getaccuracy(this.paramsPrevious)
          .then((value) => {
            this.accuracyData.previous = value.data
          })
    }
  },

  mounted() {
    this.getCurrentAccuracy();
    this.getPreviousAccuracy();
  },

  data(){
    return{
      accuracyData: {
        previous: null,
        current: null,
      }
    }
  },

  computed:{
    accuracyObject() {
      return { accuracyData: this.accuracyData, accuracyPercentage: this.accuracyData.current, accuracyPercentagePrevious: this.accuracyData.previous }
    },
    userId(){
      return this.$store.state.auth.currentUserId
    }
  },

  watch:{
    'params'(value) {
      this.getCurrentAccuracy()
    },
    'paramsPrevious' (value) {
      this.getPreviousAccuracy()
    },
    'accuracyData.current'(value){
      this.$emit('input', this.accuracyObject)
    },
    'accuracyData.previous'(value){
      this.$emit('input', this.accuracyObject)
    }
  }

}
</script>

<style scoped>

</style>